'use strict';
/* eslint-env browser */

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var normaliseInput = require('ipfs-utils/src/files/normalise-input');

var mtimeToObject = require('../lib/mtime-to-object');

exports.toFormData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var files, formData, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, file, headers, mtime, bufs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, chunk;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            files = normaliseInput(input);
            formData = new FormData();
            i = 0;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 5;
            _iterator = _asyncIterator(files);

          case 7:
            _context.next = 9;
            return _iterator.next();

          case 9:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 13;
            return _step.value;

          case 13:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 62;
              break;
            }

            file = _value;
            headers = {};

            if (file.mtime !== undefined && file.mtime !== null) {
              mtime = mtimeToObject(file.mtime);

              if (mtime) {
                headers.mtime = mtime.secs;
                headers['mtime-nsecs'] = mtime.nsecs;
              }
            }

            if (file.mode !== undefined && file.mode !== null) {
              headers.mode = file.mode.toString(8).padStart(4, '0');
            }

            if (!file.content) {
              _context.next = 57;
              break;
            }

            // In the browser there's _currently_ no streaming upload, buffer up our
            // async iterator chunks and append a big Blob :(
            // One day, this will be browser streams
            bufs = [];
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context.prev = 23;
            _iterator2 = _asyncIterator(file.content);

          case 25:
            _context.next = 27;
            return _iterator2.next();

          case 27:
            _step2 = _context.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context.next = 31;
            return _step2.value;

          case 31:
            _value2 = _context.sent;

            if (_iteratorNormalCompletion2) {
              _context.next = 38;
              break;
            }

            chunk = _value2;
            bufs.push(chunk);

          case 35:
            _iteratorNormalCompletion2 = true;
            _context.next = 25;
            break;

          case 38:
            _context.next = 44;
            break;

          case 40:
            _context.prev = 40;
            _context.t0 = _context["catch"](23);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t0;

          case 44:
            _context.prev = 44;
            _context.prev = 45;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context.next = 49;
              break;
            }

            _context.next = 49;
            return _iterator2.return();

          case 49:
            _context.prev = 49;

            if (!_didIteratorError2) {
              _context.next = 52;
              break;
            }

            throw _iteratorError2;

          case 52:
            return _context.finish(49);

          case 53:
            return _context.finish(44);

          case 54:
            formData.append("file-".concat(i), new Blob(bufs, {
              type: 'application/octet-stream'
            }), encodeURIComponent(file.path), {
              header: headers
            });
            _context.next = 58;
            break;

          case 57:
            formData.append("dir-".concat(i), new Blob([], {
              type: 'application/x-directory'
            }), encodeURIComponent(file.path), {
              header: headers
            });

          case 58:
            i++;

          case 59:
            _iteratorNormalCompletion = true;
            _context.next = 7;
            break;

          case 62:
            _context.next = 68;
            break;

          case 64:
            _context.prev = 64;
            _context.t1 = _context["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context.t1;

          case 68:
            _context.prev = 68;
            _context.prev = 69;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 73;
              break;
            }

            _context.next = 73;
            return _iterator.return();

          case 73:
            _context.prev = 73;

            if (!_didIteratorError) {
              _context.next = 76;
              break;
            }

            throw _iteratorError;

          case 76:
            return _context.finish(73);

          case 77:
            return _context.finish(68);

          case 78:
            return _context.abrupt("return", formData);

          case 79:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 64, 68, 78], [23, 40, 44, 54], [45,, 49, 53], [69,, 73, 77]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();